/**
 * Employee Web — `/me/personal` legacy redirect (Plan 05.2-05).
 *
 * The Personal tab moved to `/me/profile/personal` as part of the bundle's
 * 6-tab decomposition. This route preserves bookmarks per Critical Risk #1
 * — the old URL still works, it just bounces to the new location.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/personal")({
  beforeLoad: () => {
    throw redirect({ to: "/me/profile/personal" });
  },
});
